module.exports = "<div class=\"manage-memo\">\r\n  <h2 class=\"tmb-title\">Manage Memo MY TMB</h2>\r\n</div>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-sm-6 col-xs-12\">\r\n    <quill-editor\r\n    [(ngModel)]=\"memo\"\r\n    [options]=\"editorOptions\"\r\n    ></quill-editor>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row btn-save\">\r\n  <button  md-raised-button color=\"primary\" (click)=\"onSave()\">Save</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/manage-memo-mytmb/manage-memo-mytmb.component.html
// module id = ../../../../../src/app/pages/master-data/manage-memo-mytmb/manage-memo-mytmb.component.html
// module chunks = main